export const IS_SIGNUP_QP = "aa-is-signup";
//# sourceMappingURL=constants.js.map